import { Link } from "react-router-dom";
import { Heart, X, ShoppingCart, ArrowRight } from "@phosphor-icons/react";
import { useWishlist } from "@/context/WishlistContext";
import { useCart } from "@/context/CartContext";
import { useCurrency } from "@/context/CurrencyContext";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import StarRating from "@/components/StarRating";

export default function Wishlist() {
  const { items, toggle } = useWishlist();
  const { add } = useCart();
  const { fmt } = useCurrency();

  return (
    <>
      <SEO title="My Wishlist" description="Your saved electric bikes and accessories." path="/wishlist" />
      <PageHero title="Your wishlist" subtitle="The bikes and gear you've saved for later." image="https://images.unsplash.com/photo-1571068316344-75bc76f77890?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" crumbs={[{ label: "Wishlist" }]} />

      <section className="container-px py-12">
        {items.length === 0 ? (
          <div className="rounded-3xl border border-border bg-card p-12 text-center">
            <Heart size={56} className="mx-auto text-muted-foreground/40" />
            <p className="mt-4 text-lg font-semibold">Your wishlist is empty</p>
            <p className="mt-1 text-muted-foreground">Tap the heart on any product to save it here.</p>
            <Link to="/shop" className="btn-primary mt-6">Discover eBikes <ArrowRight size={18} /></Link>
          </div>
        ) : (
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-testid="wishlist-grid">
            {items.map((i) => (
              <div key={i.slug} className="group relative overflow-hidden rounded-3xl border border-border bg-card">
                <button onClick={() => toggle(i)} className="absolute right-3 top-3 z-10 grid h-9 w-9 place-items-center rounded-full glass" aria-label="Remove"><X size={16} /></button>
                <Link to={`/product/${i.slug}`} className="block aspect-[4/3] overflow-hidden bg-muted">
                  <img src={i.thumbnail} alt={i.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                </Link>
                <div className="p-5">
                  <Link to={`/product/${i.slug}`} className="font-bold hover:text-primary">{i.name}</Link>
                  <div className="mt-1"><StarRating value={i.rating} /></div>
                  <div className="mt-3 flex items-center justify-between">
                    <span className="text-lg font-extrabold">{fmt(i.price)}</span>
                    <button onClick={() => add({ ...i, sale_price: null })} className="inline-flex items-center gap-1.5 rounded-full bg-foreground px-4 py-2 text-sm font-semibold text-background hover:bg-primary hover:text-primary-foreground"><ShoppingCart size={15} /> Add</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </>
  );
}
